import type { TShopPromoCodeDiscountItem } from '~services/api/credits/types';

export function checkIfApplicable(
	sku: string,
	prices: TShopPromoCodeDiscountItem[]
) {
	const data = sku.replace('com.ai.web.', '');
	let type = data.split('.')[0];
	type = type.indexOf('coinpack') !== -1 ? 'coinpack' : type;
	const promoSkus = prices.map(
		({ Sku }) => Sku.replace('com.ai.web.', '').split('.')[0]
	);
	return promoSkus.some((item) => item === type || item.includes(type));
}
